<div class="contactanos-section" *ngIf="listo">
    <div class="formulario-container">
        <p class="text-center mb-4 from-title">¡Contáctanos!</p>
        <p class="texto-from text-center">Un gerente inmobiliario te podrá acompañar en todos los trámites para adquirir
            una propiedad.</p>
        <form [formGroup]="formContacto" (ngSubmit)="guardarSolicitud()" autocomplete="off">
            <!-- Busco información de y Nombre -->
            <div class="row  justify-content-center">
                <div class="col-auto" style="min-width: 360px;">
                    <div class="custom-select-wrapper" [class.open]="openedSelect === 'motivoContactoEntity'">
                        <div class="custom-select-display" (click)="toggleSelect('motivoContactoEntity')">
                            <div class="custom-select-text">
                                <label class="custom-select-label"
                                    [class.float]="!!contacto.motivoContactoEntity?.nombre">
                                    Busco información de*
                                </label>
                                <span class="selected-value" *ngIf="contacto.motivoContactoEntity">
                                    {{ contacto.motivoContactoEntity.nombre }}
                                </span>
                            </div>
                            <img src="Inmuebles/assets/iconos/vector.svg" class="arrow"
                                [style.transform]="'rotate(' + informacionRotation + 'deg)'"
                                [style.transition]="'transform 0.3s ease'">
                        </div>
                        <div class="custom-select-options" *ngIf="openedSelect === 'motivoContactoEntity'">
                            <li *ngFor="let motivo of motivoContactos" (click)="seleccionarMotivo(motivo)"
                                [class.selected]="motivo.idMotivoContacto === contacto.motivoContactoEntity?.idMotivoContacto">
                                {{ motivo.nombre }}
                            </li>
                        </div>
                    </div>
                </div>
                <div class="col-auto">
                    <div class="floating-group" [class.error]="formContacto.get('nombreCliente')?.touched && formContacto.get('nombreCliente')?.errors && formContacto.get('nombreCliente')?.value">
                        <input type="text" class="form-control" id="nombreCliente" name="nombreCliente"
                            [(ngModel)]="contacto.nombreCliente" formControlName="nombreCliente" maxlength="50" placeholder=" "
                            (focus)="nombreFocused = true" (blur)="nombreFocused = false"
                            ngModelOptions="{standalone: true}" (keypress)="soloLetras($event)"/>
                        <label class="floating-label" [class.float]="nombreFocused || contacto.nombreCliente">
                            Nombre(s)*
                        </label>
                        <div *ngIf="formContacto.get('nombreCliente')?.touched && formContacto.get('nombreCliente')?.errors">
                            <label class="helper-error" *ngIf="formContacto.get('nombreCliente')?.errors?.['longitud']">
                                Ingresa un nombre con más de 2 caracteres.
                            </label>
                            <label class="helper-error" *ngIf="formContacto.get('nombreCliente')?.errors?.['repetidos']">
                                No repitas caracteres seguidos.
                            </label>
                        </div>
                    </div>
                </div>

            </div>
            <!-- Apellido apellido1 y Apellido apellido2 -->
            <div class="row justify-content-center">
                <div class="col-auto">
                    <div class="floating-group" [class.error]="formContacto.get('apellido1')?.touched && formContacto.get('apellido1')?.errors && formContacto.get('apellido1')?.value">
                        <input type="text" class="form-control" formControlName="apellido1"
                            [(ngModel)]="contacto.apellido1" name="apellido1" maxlength="50" placeholder=" " (keypress)="soloLetras($event)">
                        <label class="floating-label">Apellido 1*</label>
                        <div *ngIf="formContacto.get('apellido1')?.touched && formContacto.get('apellido1')?.errors">
                            <label class="helper-error" *ngIf="formContacto.get('apellido1')?.errors?.['longitud']">
                                Ingresa un apellido con más de 2 caracteres.
                            </label>
                            <label class="helper-error" *ngIf="formContacto.get('apellido1')?.errors?.['repetidos']">
                                No repitas caracteres seguidos.
                            </label>
                        </div>
                    </div>
                </div>
                <div class="col-auto ">
                    <div class="floating-group" [class.error]="formContacto.get('apellido2')?.touched && formContacto.get('apellido2')?.errors && formContacto.get('apellido2')?.value">
                        <input type="text" class="form-control" formControlName="apellido2" [(ngModel)]="contacto.apellido2"
                            name="apellido2" maxlength="50" placeholder=" " (keypress)="soloLetras($event)">
                        <label class="floating-label">Apellido 2 (Opcional)</label>
                        <div *ngIf="formContacto.get('apellido2')?.touched && formContacto.get('apellido2')?.errors">
                            <label class="helper-error" *ngIf="formContacto.get('apellido2')?.errors?.['longitud']">
                                Ingresa un apellido con más de 2 caracteres.
                            </label>
                            <label class="helper-error" *ngIf="formContacto.get('apellido2')?.errors?.['repetidos']">
                                No repitas caracteres seguidos.
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Correo y Teléfono Móvil -->
            <div class="row justify-content-center">
                <div class="col-auto">
                    <div class="floating-group">
                        <input type="email" class="form-control" formControlName="correoECliente"
                            [(ngModel)]="contacto.correoECliente" name="correoECliente" id="correoECliente"
                            placeholder=" ">
                        <label class="floating-label">Correo electrónico*</label>
                    </div>
                </div>
                <!-- Teléfono móvil -->
                <div class="col-auto">
                    <div class="floating-group" [class.error]="formContacto.get('telCasaCliente')?.touched && formContacto.get('telCasaCliente')?.errors && formContacto.get('telCasaCliente')?.value">
                        <input type="tel" class="form-control" formControlName="telCasaCliente"
                            [(ngModel)]="contacto.telCasaCliente" name="telCasaCliente" pattern="[0-9]*" maxlength="10"
                            (keypress)="isNumberKey($event)" placeholder=" ">
                        <label class="floating-label">Teléfono móvil*</label>
                        <!-- Mensaje de error -->
                        <div *ngIf="formContacto.get('telCasaCliente')?.touched && formContacto.get('telCasaCliente')?.errors">
                            <label class="helper-error" *ngIf="formContacto.get('telCasaCliente')?.errors?.['repetidos5']">
                                No repitas el mismo dígito más de 5 veces seguidas.
                            </label>
                            <label class="helper-error" *ngIf="formContacto.get('telCasaCliente')?.errors?.['telefonoInvalido']">
                                Ingresa el teléfono móvil a 10 dígitos.
                            </label>
                        </div>
                    </div>
                </div>
                <!-- Teléfono fijo (opcional) -->
                <div class="row justify-content-center">
                    <div class="col-auto">
                        <div class="floating-group" [class.error]="formContacto.get('telOficinaCliente')?.touched && formContacto.get('telOficinaCliente')?.errors && formContacto.get('telOficinaCliente')?.value">
                            <input type="tel" class="form-control" formControlName="telOficinaCliente"
                                [(ngModel)]="contacto.telOficinaCliente" name="telOficinaCliente" maxlength="10"
                                pattern="[0-9]*" (keypress)="isNumberKey($event)" placeholder=" ">
                            <label class="floating-label">Teléfono fijo (Opcional)</label>
                            <!-- Mensaje de error -->
                            <div *ngIf="formContacto.get('telOficinaCliente')?.touched && formContacto.get('telOficinaCliente')?.errors">
                                <label class="helper-error" *ngIf="formContacto.get('telOficinaCliente')?.errors?.['repetidos5']">
                                    No repitas el mismo dígito más de 5 veces seguidas.
                                </label>
                                <label class="helper-error" *ngIf="formContacto.get('telOficinaCliente')?.errors?.['telefonoInvalido']">
                                    Ingresa el teléfono móvil a 10 dígitos.
                                </label>
                            </div>
                        </div>
                    </div>
                
                <div class="col-auto margen espacio-columna" style="background: transparent;">
                    <div class="floating-group" style="background: transparent;">
                    </div>
                </div>
                </div>
            </div>
            <!-- Comentarios -->
            <div class="row mb-3 justify-content-center">
                <div class="col-12">
                    <div class="floating-textarea" style="height: 70px; max-width: 750px;">
                        <textarea class="custom-input text-from" formControlName="comentarioCliente"
                            [(ngModel)]="contacto.comentarioCliente" name="comentarioCliente" id="comentarioCliente"
                            maxlength="100" placeholder=" " style="width: 100%;"></textarea>
                        <label class="floating-label-textarea">Escribe un mensaje</label>
                    </div>
                    <div class="text-end text-muted text-campo mt-4">
                        {{ formContacto.get('comentarioCliente')?.value?.length || 0 }}/100
                    </div>

                </div>
                <div class="row mb-4 justify-content-center">
                    <div class="col-12">
                        <p class="text-campoo">Los campos marcados con (<span>*</span>) son obligatorios.</p>
                    </div>
                </div>
            </div>
            <!-- Preferencia de contacto -->
            <div class="row justify-content-center align-items-center mb-2">
                <div class="col-auto text-center">
                    <label class="mb-2 text-camp-title">Recibir información a través
                        de:<span>*</span></label><br>
                    <div class="radios-contacto">
                        <div class="form-check">
                            <input type="radio" class="custom-radio" formControlName="idPrefContacto" [value]="2"
                                id="contactoCorreo">
                            <label class="form-check-label text-campo" for="contactoCorreo">Correo electrónico</label>
                        </div>
                        <div class="form-check">
                            <input type="radio" class="custom-radio" formControlName="idPrefContacto" [value]="1"
                                id="contactoTelefono">
                            <label class="form-check-label text-campo" for="contactoTelefono">Teléfono</label>
                        </div>
                        <div class="form-check">
                            <input type="radio" class="custom-radio" formControlName="idPrefContacto" [value]="3"
                                id="contactoAmbos">
                            <label class="form-check-label text-campo" for="contactoAmbos">Ambos</label>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Botones -->
            <div class="text-center mt-4" style="display: flex; justify-content: center; gap: 20px;">
                <button type="button" (click)="limpiar()" class="btn-cancelar">Cancelar</button>
                <button type="submit" class="btn-enviar" [disabled]="!formContacto.valid || enviado">Enviar</button>
            </div>
        </form>
    </div>
</div>